export default __webpack_public_path__ + "static/media/back.c873a788.svg";